module.exports = __webpack_public_path__ + "static/media/ra.32145594.ogg";